import type { MemberStatus } from '@web/data/repositories';
import { t } from '@web/i18n';
import { Dot, type DotVariantProps } from '@web/ui/core';
import { twcn } from '@web/ui/core/utils';

const TONE: Record<MemberStatus, NonNullable<DotVariantProps['tone']>> = {
  active: 'green',
  inactive: 'gray',
  suspended: 'red',
};

const LABEL_CLASS: Record<MemberStatus, string> = {
  active: 'text-tone-green-ink',
  inactive: 'text-faint-foreground',
  suspended: 'text-tone-red-ink',
};

export function StatusChip({ status }: Readonly<{ status: MemberStatus }>): React.JSX.Element {
  return (
    <span className="inline-flex items-center gap-1.5 text-meta text-foreground">
      <Dot tone={TONE[status]} />
      <span className={twcn(LABEL_CLASS[status])}>{t(`members.status.${status}`)}</span>
    </span>
  );
}
